import React, { useEffect } from "react";
import { connect } from "react-redux";
import { languages } from "../../helpers/language";
import { signUp, orderOnline } from "../../helpers/icons";
import { fetchLimitedTimeOfferProgram } from "../../actions/merchantActions";

const LimitedTimeOfferProgramSection = ({
    appStateData,
    merchantData,
    fetchLimitedTimeOfferProgram,
}) => {
    const { customerId, shopDomain } = appStateData;
    let { merchant, limitedTimeOfferProgram } = merchantData;

    const details = {
        limited_time_offer_program_title:
            languages[merchant?.theme?.language || "en"]["main.limited_time_offer_program_title"],
        limited_time_offer_program_desc:
            languages[merchant?.theme?.language || "en"]["main.limited_time_offer_program_desc"],
    };

    useEffect(() => {
        fetchLimitedTimeOfferProgram(shopDomain);
    }, [customerId]);

    function formatDate(inputDateStr) {
        const inputDate = new Date(inputDateStr);

        const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        const weekday = weekdays[inputDate.getDay()];
        const month = months[inputDate.getMonth()];
        const day = inputDate.getDate();
        const year = inputDate.getFullYear();

        const outputDateStr = `Valid till ${weekday} ${month} ${day}, ${year}`;

        return outputDateStr;
    }

    function isOfferValid(offers, type) {
        return offers?.some(offer =>
            offer?.status === 'active' &&
            offer?.type === type &&
            (new Date() >= new Date(offer.offerDuration.startDate) &&
                new Date() <= new Date(offer?.offerDuration.endDate + 'T23:59:59'))
        );
    }

    if (
        (!customerId && !isOfferValid(limitedTimeOfferProgram?.offers, 'signup')) ||
        (customerId && !isOfferValid(limitedTimeOfferProgram?.offers, 'order'))
    ) {
        return null;
    }

    return (
        <div className="limitedTimeOfferProgram-section-wrapper">
            <div className="limitedTimeOfferProgram-heading-container">
                <h2 className="limitedTimeOfferProgram-heading">{details.limited_time_offer_program_title}</h2>
                <p className="limitedTimeOfferProgram-desc">{details.limited_time_offer_program_desc}</p>
            </div>
            <div className="limitedTimeOfferProgram-items-wrapper">
                {Array.isArray(limitedTimeOfferProgram?.offers) && limitedTimeOfferProgram?.offers?.length > 0 && (
                    limitedTimeOfferProgram?.offers
                        .filter(offer =>
                            offer?.status === 'active' &&
                            (customerId ? offer?.type === 'order' : offer?.type === 'signup') &&
                            new Date() >= new Date(offer?.offerDuration.startDate) &&
                            new Date() <= new Date(offer?.offerDuration.endDate + 'T23:59:59')
                        )
                        .map((offer, i, array) => {
                            return (
                                <div key={offer?._id} className="limitedTimeOffer-item-container">
                                    <div className="limitedTimeOffer-icon-title-container">
                                        <div className="limitedTimeOffer-icon-container">
                                            <img
                                                src={merchant?.theme?.icons?.order?.type === "custom"
                                                    ? merchant?.theme?.icons?.order?.location
                                                    : customerId ? orderOnline(merchant?.customWidgetTheme?.iconcolor)
                                                        : signUp(merchant?.customWidgetTheme?.iconcolor)}
                                                alt="item-img"
                                            />
                                        </div>
                                        <div className="limitedTimeOffer-title-container">
                                            <h3>{offer?.onSiteReminder?.title}</h3>
                                        </div>
                                    </div>
                                    <div className="limitedTimeOffer-rewards-container">
                                        <p>{offer?.onSiteReminder?.description}</p>
                                        <span>{formatDate(offer?.offerDuration?.endDate)}</span>
                                    </div>
                                </div>
                            );
                        })
                )}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    merchantData: state.MerchantReducer,
    appStateData: state.AppstateReducer,
    customerData: state.CustomerReducer,
});

const mapDispatchToProps = (dispatch) => ({
    fetchLimitedTimeOfferProgram: (shopDomain) => dispatch(fetchLimitedTimeOfferProgram(shopDomain)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LimitedTimeOfferProgramSection);